<template>
  <section class="pdf-content">
    <page-counter-start/>

    <Cover :ba="ba" :immobilie="immobilie" :lang="lang"/><!--Zusammenfassung Bewertungen-->
    <Arbeitsflaeche :ba="ba" :immobilie="immobilie" :lang="lang"/><!--Arbeitsflaeche Mast-->
    <Zuwegung :ba="ba" :immobilie="immobilie" :lang="lang"/><!--Zuwegung Mast-->
    <Seilzugflaechen :ba="ba" :immobilie="immobilie" :lang="lang"/><!--Seilzugflaechen-->
    <Schutzgerueste :ba="ba" :immobilie="immobilie" :lang="lang"/><!--Schutzgerüste-->
    <Fremdleitung :ba="ba" :immobilie="immobilie" :lang="lang"/><!--Fremdleitung-->
    <Anmerkungen :ba="ba" :immobilie="immobilie" :lang="lang"/><!--Anmerkungen/Hinweise auf der Karte-->
    <page-counter-end/>
  </section>
</template>
  
  <script lang="ts">
    import useUser from '@/composables/useUser';
    import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
    import Immobilie from '@/models/immobilie.model';
    import { defineComponent, PropType, watch } from 'vue';
    import { useI18n } from 'vue-i18n';
    import Cover from './CoverPage.vue';
    import Arbeitsflaeche from './ArbeitsflaecheMast.vue';
    import Zuwegung from './ZuwegungMast.vue';
    import Seilzugflaechen from './Seilzugflaechen.vue'
    import Schutzgerueste from './Schutzgerueste.vue';
    import Fremdleitung from './Fremdleitung.vue';
    import Anmerkungen from './Anmerkungen.vue';
    import PdfA4Page from '../Components/PdfA4Page.vue';
    import PageCounterStart from '@/components/Pdf/Components/PageCounterStart';
    import PageCounterEnd from '@/components/Pdf/Components/PageCounterEnd';
  
    export default defineComponent({
      name: 'PdfNewVationTemplate',
      components: {
        PdfA4Page,
        PageCounterEnd,
        PageCounterStart,
        Cover,
        Arbeitsflaeche,
        Zuwegung,
        Seilzugflaechen,
        Schutzgerueste,
        Fremdleitung,
        Anmerkungen
      },
      props: {
        ba: {
          type: Object as PropType<Bestandsaufnahme>,
          required: true,
        },
        immobilie: {
          type: Object as PropType<Immobilie>,
          required: true,
        },
        lang: {
          type: String,
          default: 'de',
        },
      },
      methods: {
        InputDefaultVal() {
          document.querySelectorAll('[data-cy]').forEach(element => {
            if (element.nodeName === 'IMG' || element.innerHTML.trim() !== "")
              return;
            if (element.textContent?.trim() === '')
              element.textContent = 'Unbekannt';
          });
        },
      },
      setup(props: any) {
        const { t } = useI18n({ useScope: 'global' });
        const uUser = useUser();
        return {
          user: uUser.user,
          t,
        };
      },
      mounted() {
        this.InputDefaultVal();
      },
    });
  </script>
  
  <style scoped>
    * {
      color: black;
      background-color:#3c3c3c !important;
      font-size: 12px !important;
    }
    .pdf-content {
      width: 800px !important;
      margin: 0 auto;
      color: var(--white100);
    }
    .report-background {
      position: absolute;
      top: 50px;
      left: 50px;
      width: 700px;
      height: 800px;
      color: var(--black100);
    }
    .no-pic {
      height: 150px;
      max-height: 150px;
      background-color: rgb(235, 239, 240);
      border-radius: 5px;
      border-style: solid;
      border-color: rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240);    
    }
  </style>